import { type FunctionComponent } from 'react';
import Link from 'next/link';
import classes from './NavigationMobile.module.css';
import cx from 'clsx';
import { navigationItems } from '@/lib/data/primaryNavigation';
import useSectionNavigation from '@/hooks/useSectionNavigation';
import { useFeatureFlag } from '@/contexts/FeatureFlag';

export interface NavigationMobileProps {}

navigationItems;

const NavigationMobile: FunctionComponent<NavigationMobileProps> = () => {
  const { selectedItem } = useSectionNavigation({
    navigationItems,
  });
  const navFeatures =
    useFeatureFlag(
      ...navigationItems
        .map(({ featureFlag }) => featureFlag)
        .filter((_) => _ !== undefined)
    ) ?? {};

  const enabledNavigationItems = navigationItems.flatMap(
    ({ featureFlag, ...others }) => {
      const enabled = featureFlag ? navFeatures[featureFlag] : true;
      return enabled ? [others] : [];
    }
  );

  return (
    <nav aria-label="Main" className={cx(classes.root)}>
      <ul className={cx(classes.list)}>
        {enabledNavigationItems.map(({ href, label }) => (
          <li key={href}>
            <Link
              href={href}
              className={cx(classes.link, {
                [classes.selected]: selectedItem?.href === href,
              })}>
              <span>{label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavigationMobile;
